import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { BottomNavigation } from './components/Layout/BottomNavigation';
import { Home } from './pages/Home';
import { SmartPay } from './pages/SmartPay';
import { Trade } from './pages/Trade';
import { B2B } from './pages/B2B';
import { Assets } from './pages/Assets';
import { Buy } from './pages/Buy';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/smartpay" element={<SmartPay />} />
          <Route path="/trade" element={<Trade />} />
          <Route path="/b2b" element={<B2B />} />
          <Route path="/assets" element={<Assets />} />
          <Route path="/buy" element={<Buy />} />
        </Routes>
        <BottomNavigation />
      </div>
    </Router>
  );
}

export default App;